
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqmGOwC8YureADxpgMFFQzgraUtjxWPwCJj0LU30puPkkMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/faq.vue?macro=true";
import { default as about3fEJ1zcHZfgeipp11uzAPlx1y9OAA8HqUPLW6e3CW6gMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/about.vue?macro=true";
import { default as offerm8aOqdupflsxfHoI8KILU6E6l4_GjhBUpneEnRZ4VisMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/offer.vue?macro=true";
import { default as privacy4pFA0US_jNQpFqFe5iEv7GDpXAL5korys8ZIoThJzS0Meta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/privacy.vue?macro=true";
import { default as returns1oepnxrne171sUEPddiUVzHj99aO1JsY06lwl2ygl7cMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/returns.vue?macro=true";
import { default as agreementwQt_o5tgONGniIadNs7Ta1mdTTlUzygJprTvCIg49ScMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/agreement.vue?macro=true";
import { default as indexcu47TeElew1U8SbxJMDsMGnKcW4IU_x89adZTXe3QS0Meta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/blog/index.vue?macro=true";
import { default as indexOI3pMOO6HxP_E13GZ9zBAGYnm__xiEZylK9Dr2Im_1YMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/news/index.vue?macro=true";
import { default as _91slug_93lfm_tH52gkkfKhwhfPozdQHyz6LkAOxMrRy_vlkPUe4Meta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/blog/[slug].vue?macro=true";
import { default as _91slug_93Tn4BJXDSLB_JnBtJOc1T8DzQRhIX4oXDUQDrQKAo2PoMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/news/[slug].vue?macro=true";
import { default as indexximbfXo6gk6d_FN3U2ezRkXPROiVIwwpDBL6nsxiKSEMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/index.vue?macro=true";
import { default as _91slug_93BBHDoWvBsVMUiuzy1hXv_Cge5jQGjecm5cPdnoBMG1gMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/pages/[slug].vue?macro=true";
import { default as _91id_9392G0C4Jm8hVtOmTVfE1habeD2UW1hO4Uq4gSqMiR6Y0Meta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/product/[id].vue?macro=true";
import { default as indexhtT8DHDpsbb1OtF_VKBtTLc7ereVzuiK4dNukae48lgMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/search/index.vue?macro=true";
import { default as data_45transferagqFwyqLAKA19ZdRUwQGSznhh_OfvxCB_TiDKdJPMJ8Meta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/data-transfer.vue?macro=true";
import { default as indexDMUF_Gpfgp9zDwpA8It62Ycgg_vvBarlRadKedSke_UMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/index.vue?macro=true";
import { default as _91tab_93AeCECVGr6Hb95pgB840qp8TOh6IUEk0BVc_rWJNoU4MMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders/[tab].vue?macro=true";
import { default as OrdersLpI2byOT92CPS62hp29D_jVj06_XKciYuWgwtjSc4NwMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders.vue?macro=true";
import { default as _91id_93tQ3KC4LFTFNOvChvtzLaLWgQOWwF6vofrZPiYnn4TeUMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Detail/[id].vue?macro=true";
import { default as indexMpnb0wDBoj08Ah1WHmuXDjSVRfF5GkK8_qdOuUzGVAEMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/[[category]]/index.vue?macro=true";
import { default as indexfgo7MTbesD_H1w121urk3HJQ2vDNk4aB1F8_Dp_OyLQMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Create/index.vue?macro=true";
import { default as index_5JCDw_M5aph3wbl14tSRDYa1V_VmlivXwpZ0960_scMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/Edit/index.vue?macro=true";
import { default as indexnIXvODZduOgNuKEokCeMs_a8CVkmnpaDqsgWGNe8J74Meta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Loyalty/pages/Profile/Loyalty/index.vue?macro=true";
import { default as indexjdveruy3hVBTPNVnBzg_yuwra7Kh6__EZ4Wdg6_yctoMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Reviews/pages/Profile/Reviews/index.vue?macro=true";
import { default as indexblCD2FPtBjJZqxGC05_u7btWcQGlj8x82_IXM1CkuSkMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Favorites/pages/Profile/Favorites/index.vue?macro=true";
import { default as indexDxShW_v4A32YTOuX4nSYNuWaeNJ3kVQar4pNv1Fa7mgMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Fail/index.vue?macro=true";
import { default as indexB4Y_Pr_nAKS__Oeo4TEqE1ZyK8W5VU168WbRM5DisBUMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/catalog/[[category]]/index.vue?macro=true";
import { default as indexHBDZV6Too5CjbDH5r_8vwOOeTTB3xt8WdjJbmTGPyXMMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Success/index.vue?macro=true";
import { default as indexs4PhkvqKUVQbriESJlysjcDZfXNGAvjSKuYdBLiIysIMeta } from "/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Notifications/pages/Profile/Notifications/index.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/faq.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/about.vue")
  },
  {
    name: "offer",
    path: "/offer",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/offer.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/privacy.vue")
  },
  {
    name: "returns",
    path: "/returns",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/returns.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/agreement.vue")
  },
  {
    name: "BlogIndex",
    path: "/blog",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/blog/index.vue")
  },
  {
    name: "NewsIndex",
    path: "/news",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/news/index.vue")
  },
  {
    name: "BlogDetails",
    path: "/blog/:slug()",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/blog/[slug].vue")
  },
  {
    name: "NewsDetails",
    path: "/news/:slug()",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/news/[slug].vue")
  },
  {
    name: "OrderIndex",
    path: "/Order",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/index.vue")
  },
  {
    name: "ContentPageDetails",
    path: "/pages/:slug()",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/pages/[slug].vue")
  },
  {
    name: "ProductsDetails",
    path: "/product/:id()",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/product/[id].vue")
  },
  {
    name: "ProductsSearch",
    path: "/search",
    meta: indexhtT8DHDpsbb1OtF_VKBtTLc7ereVzuiK4dNukae48lgMeta || {},
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/search/index.vue")
  },
  {
    name: "data-transfer",
    path: "/data-transfer",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/data-transfer.vue")
  },
  {
    name: "ProfileIndex",
    path: "/Profile",
    meta: { ...(indexDMUF_Gpfgp9zDwpA8It62Ycgg_vvBarlRadKedSke_UMeta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/index.vue")
  },
  {
    name: "Profile-Orders",
    path: "/Profile/Orders",
    redirect: "/profile/orders/active",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders.vue"),
    children: [
  {
    name: "ProfileOrdersTab",
    path: ":tab()",
    meta: { ...(_91tab_93AeCECVGr6Hb95pgB840qp8TOh6IUEk0BVc_rWJNoU4MMeta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders/[tab].vue")
  }
]
  },
  {
    name: "OrderDetail",
    path: "/Order/Detail/:id()",
    meta: _91id_93tQ3KC4LFTFNOvChvtzLaLWgQOWwF6vofrZPiYnn4TeUMeta || {},
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Detail/[id].vue")
  },
  {
    name: "ProductsIndex",
    path: "/:category?",
    meta: indexMpnb0wDBoj08Ah1WHmuXDjSVRfF5GkK8_qdOuUzGVAEMeta || {},
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/[[category]]/index.vue")
  },
  {
    name: "OrderCreate",
    path: "/Order/Create",
    meta: indexfgo7MTbesD_H1w121urk3HJQ2vDNk4aB1F8_Dp_OyLQMeta || {},
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Create/index.vue")
  },
  {
    name: "ProfileEdit",
    path: "/Profile/Edit",
    meta: { ...(index_5JCDw_M5aph3wbl14tSRDYa1V_VmlivXwpZ0960_scMeta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/Edit/index.vue")
  },
  {
    name: "LoyaltyIndex",
    path: "/Profile/Loyalty",
    meta: { ...(indexnIXvODZduOgNuKEokCeMs_a8CVkmnpaDqsgWGNe8J74Meta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Loyalty/pages/Profile/Loyalty/index.vue")
  },
  {
    name: "ReviewsIndex",
    path: "/Profile/Reviews",
    meta: { ...(indexjdveruy3hVBTPNVnBzg_yuwra7Kh6__EZ4Wdg6_yctoMeta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Reviews/pages/Profile/Reviews/index.vue")
  },
  {
    name: "FavoritesIndex",
    path: "/Profile/Favorites",
    meta: { ...(indexblCD2FPtBjJZqxGC05_u7btWcQGlj8x82_IXM1CkuSkMeta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Favorites/pages/Profile/Favorites/index.vue")
  },
  {
    name: "OrderPaymentFail",
    path: "/Order/Payment/Fail",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Fail/index.vue")
  },
  {
    name: "ProductsCatalog",
    path: "/catalog/:category?",
    meta: indexB4Y_Pr_nAKS__Oeo4TEqE1ZyK8W5VU168WbRM5DisBUMeta || {},
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/catalog/[[category]]/index.vue")
  },
  {
    name: "OrderPaymentSuccess",
    path: "/Order/Payment/Success",
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Success/index.vue")
  },
  {
    name: "NotificationsIndex",
    path: "/Profile/Notifications",
    meta: { ...(indexs4PhkvqKUVQbriESJlysjcDZfXNGAvjSKuYdBLiIysIMeta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/fashion-shop-template/projects/web/apps/web/app/AltApplication/Modules/Notifications/pages/Profile/Notifications/index.vue")
  }
]